import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { AuthLayout } from '@/components/layout/AuthLayout'
import { ROUTES } from '@/config/routes'

export const ResetPasswordSentPage = () => {
  return (
    <AuthLayout>
      <Card>
        <CardHeader>
          <CardTitle>Check Your Email</CardTitle>
          <CardDescription>Password reset instructions have been sent</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="rounded-md bg-blue-50 p-4 text-sm text-blue-800">
            We've sent password reset instructions to your email address.
            Please check your inbox and follow the link to reset your password.
            <br /><br />
            If you don't see the email, please check your spam folder.
          </div>
        </CardContent>
        <CardFooter>
          <Button asChild variant="outline" className="w-full">
            <Link to={ROUTES.LOGIN}>
              Back to Login
            </Link>
          </Button>
        </CardFooter>
      </Card>
    </AuthLayout>
  )
}
